import { z } from "zod";
import { RarityRefSchema } from "./rarity.js";
import { StatsSchema } from "./stats.js";
import { EpochMillisSchema } from "./common.js";
/**
 * ItemStack → JSON (WEBAPI_SPEC §7.4) + snapshots d'inventaire (R4/R5/R6).
 * Chaque item non-air sérialisé porte matière, nom FR, rareté, modèle, stats, enchants, lore.
 */
/** Un enchantement porté par un item : {key, level}. */
export const ItemEnchantSchema = z.object({
    key: z.string(),
    level: z.number().int(),
});
/** Durabilité si Damageable. */
export const DurabilitySchema = z.object({
    damage: z.number().int().nonnegative(),
    max: z.number().int().nonnegative(),
});
/**
 * Item sérialisé (§7.4). Aligné 1:1 sur le JSON émis par ItemStackJson.
 * Note : `frName` = nom d'affichage FR (MiniMessage strippé) — alias `displayName` du spec.
 */
export const InventoryItemSchema = z.object({
    material: z.string(),
    amount: z.number().int().min(0),
    /** displayName plain FR (spec §7.4 "displayName"). */
    frName: z.string().nullable(),
    custom: z.boolean(),
    /** ItemFactory.idOf — null si vanilla. */
    itemId: z.string().nullable(),
    /** ItemFactory.typeOf (ex "epee"). */
    type: z.string().nullable(),
    rarity: RarityRefSchema.nullable(),
    /** ItemFactory.levelOf (pré-requis d'équipement). */
    level: z.number().int().nullable(),
    /** ItemMeta#getItemModel NamespacedKey (rendu resource pack). */
    itemModel: z.string().nullable(),
    /** ItemMeta#getCustomModelData (nullable). */
    customModelData: z.number().int().nullable(),
    stats: StatsSchema,
    enchants: z.array(ItemEnchantSchema),
    lore: z.array(z.string()),
    durability: DurabilitySchema.nullable(),
});
/** Slot d'inventaire : item ou null (vide). */
export const InventorySlotSchema = InventoryItemSchema.nullable();
/**
 * Snapshot d'inventaire complet (R4/R5).
 * main[36], armor[4], offhand, ender[27]. `live` distingue lecture live / snapshot offline.
 */
export const InventorySnapshotSchema = z.object({
    main: z.array(InventorySlotSchema),
    armor: z.array(InventorySlotSchema),
    offhand: InventorySlotSchema,
    ender: z.array(InventorySlotSchema),
    live: z.boolean(),
    updatedAt: EpochMillisSchema,
});
/**
 * Gear équipé + stats agrégées pour le radar Armory (R6).
 * slots : casque/plastron/jambières/bottes/mainhand/offhand. stats : totaux par Stat.
 */
export const GearSlotsSchema = z.object({
    helmet: InventorySlotSchema,
    chestplate: InventorySlotSchema,
    leggings: InventorySlotSchema,
    boots: InventorySlotSchema,
    mainhand: InventorySlotSchema,
    offhand: InventorySlotSchema,
});
export const GearSchema = z.object({
    slots: GearSlotsSchema,
    stats: StatsSchema,
    live: z.boolean(),
    updatedAt: EpochMillisSchema,
});
//# sourceMappingURL=inventory.js.map